
export enum ViewType {
    table = 1,
    pivot = 2,
    card = 4,
    history = 8,
    settings = 16
}
